<script>
import { Doughnut } from 'vue-chartjs'
export default {
  name: 'TopAccountsChart',
  extends: Doughnut,
  props: ['topAccounts'],
  data () {
    return {
      data: {
        labels: this.topAccounts.usernames,
        datasets: [{
          backgroundColor: ['gold', 'blue', 'red', 'lightblue', '#01c6a4'],
          pointBackgroundColor: ['gold', 'blue', 'red', 'lightblue', '#01c6a4'],
          data: this.topAccounts.downloads
        }]
      },
      options: {
        legend: {
          display: true
        },
        cutoutPercentage: 80,
        maintainAspectRatio: false
      }
    }
  },
  mounted () {
    this.renderChart(this.data, this.options)
  },
  methods: {

  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TopAccountsChart.vue